var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAssetimage = function SvgAssetimage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.17,
    height: 22.17,
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1177FE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.75 10.5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1177FE",
    strokeWidth: 1.5,
    d: "M2.918 14c0-5.225 0-7.838 1.623-9.461S8.776 2.916 14 2.916s7.838 0 9.46 1.623c1.624 1.623 1.624 4.235 1.624 9.46s0 7.838-1.623 9.46c-1.623 1.624-4.235 1.624-9.46 1.624s-7.838 0-9.461-1.623S2.918 19.225 2.918 14Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1177FE",
    strokeWidth: 1.5,
    d: "M5.836 24.5c5.1-6.096 10.82-14.135 19.248-8.7"
  })));
};
export default SvgAssetimage;